"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = canUseDOM;
/**
 * Check if DOM is accessible (SSR)
 *
 * @returns {boolean} is DOM available
 */
function canUseDOM() {
  return !!(typeof window !== 'undefined' && window.document && window.document.createElement);
}